import { sumBy } from 'lodash';
import { map } from 'lodash';
import { capitalize, find, round } from 'lodash';
import { useRef } from 'react';
import { CSVLink } from 'react-csv';
import { Button, Card } from 'reactstrap';
import './style.css';

const colstyle = {
  width: '30%',
};
const tableStyle = {
  width: '100%',
};

const CustomerInvoice = ({
  invoiceData = [],
  chargersDetails = [],
  startDate = '',
  endDate = '',
}) => {
  // const print = () => {
  //   const pdf = new jsPDF();
  //   pdf.html(document.getElementById('invoice'), {
  //     html2canvas: {
  //       // insert html2canvas options here, e.g.
  //       scale: 0.15,
  //     },
  //     callback: function (doc) {
  //       doc.save();
  //     },
  //     x: 10,
  //     y: 10,
  //   });
  // };
  const csvLinkRef = useRef();
  const exportToCSV = () => {
    csvLinkRef?.current?.link.click();
  };

  const sumByKey = (sesData, key) => round(sumBy(sesData, key), 2);

  const print = () => {
    if (!invoiceData || invoiceData?.length === 0) return [];
    let formattedSessions = map(invoiceData, (c) => {
      return {
        ChargerId: c.CPID,
        'Charger Name': getChargerDetails(c.CPID),
        'Partner Type': capitalize(c.PARTNER_TYPE.replace(/_/g, ' ')),
        'Commission/Unit': `${getSuffixPrefixOfComission(
          c?.COMMISSION_TYPE,
          c?.COMMMISION_VALUE,
        )}`,
        'KWh Consumed': `${round(c.KWH_CONSUMED, 2)} KWh`,
        'Amount (excl. tax)': `₹${round(c.COMMISSION_AMOUNT_WITHOUT_TAX, 2)}`,
        'CGST (9%)': `₹${round(c.CGST, 2)}`,
        'SGST (9%)': `₹${round(c.SGST, 2)}`,
        'Net Amount': `₹${round(c.COMMISSION_AMOUNT, 2)}`,
      };
    });

    const rowOfTotals = {
      ChargerId: '',
      'Charger Name': '',
      'Partner Type': '',
      'Commission/Unit': '',
      'KWh Consumed': `${sumByKey(invoiceData, 'KWH_CONSUMED')} KWh`,
      'Amount (excl. tax)': `₹${sumByKey(
        invoiceData,
        'COMMISSION_AMOUNT_WITHOUT_TAX',
      )}`,
      'CGST (9%)': `₹${sumByKey(invoiceData, 'CGST')}`,
      'SGST (9%)': `₹${sumByKey(invoiceData, 'SGST')}`,
      'Net Amount': `₹${sumByKey(invoiceData, 'COMMISSION_AMOUNT')}`,
    };
    formattedSessions.push(rowOfTotals);
    return formattedSessions;
  };

  const getChargerDetails = (cpid) => {
    if (!cpid) return null;
    const charger = find(chargersDetails, { ID: cpid });
    return charger?.ADDRESS;
  };

  const getSuffixPrefixOfComission = (commissionType, value) => {
    let response = '';
    if (commissionType === 'PERCENTAGE') {
      response = `${value}%`;
    } else if (commissionType === 'FIXED') {
      response = `₹${round(value / 100, 2)}`;
    }
    return response;
  };

  return (
    <Card className="shadow" style={{ marginTop: 10, padding: 10 }}>
      <div id="invoice">
        <div className="invoice-heading">
          <h2>Sample Invoice</h2>
          <Button
            onClick={() => exportToCSV()}
            style={{
              backgroundColor: '#2675b8 !important',
              float: 'right',
              background: '#2675b8',
              color: 'white',
              fontSize: '14px',
              borderRadius: '5px',
            }}
          >
            <span className="fa fa-download" style={{ marginRight: 10 }} />
            Download Incoice
          </Button>
          <CSVLink
            ref={csvLinkRef}
            data={print()}
            filename="Invoice.csv"
            separator=","
            className="csv-button"
            style={{
              display: 'none',
            }}
          >
            Export as CSV
          </CSVLink>
        </div>
        <div className="invoice-date">
          <h4>
            Invoice Date – {startDate} to {endDate}
          </h4>
        </div>
        {/* <div>
          <Row style={{ margin: 0 }}>
            <Col className="border">
              <div>To</div>
              <div>
                <strong>Ganesh Agencies</strong>
              </div>
              <div>Plot No.P-12, M.I.D.C., Ahmednagar</div>
              <div>Industrial Area, Ahmednagar – 414111.</div>
              <div>GST – 27AAEPZ5779K1ZP</div>
              <div>PAN - AAEPZ5779K</div>
            </Col>
            <Col className="border">
              <div>From</div>
              <div>
                <strong>Joulepoint Private Limited</strong>
              </div>
              <div>3-1-429, Maitri nagar colony, Dhanapuram,</div>
              <div>L B nagar, Hyderabad, Telangana, 500074</div>
              <div>GST – 36AAFCJ0238H1ZR</div>
              <div>PAN – AAFCJ0238H</div>
            </Col>
          </Row>
        </div> */}
        <table
          id="tab_customers"
          class="table1 table-striped1"
          style={tableStyle}
        >
          <colgroup>
            <col span="1" style={colstyle} />
            <col span="1" style={colstyle} />
          </colgroup>
          <thead>
            <tr class="warning">
              <th className="w-lg">ChargerId</th>
              <th className="w-lg">Charger Name</th>
              <th>Partner Type</th>
              <th>Commission/Unit</th>
              <th>KWh Consumed</th>
              <th>Amount (excl. tax)</th>
              <th>CGST (9%)</th>
              <th>SGST (9%)</th>
              <th>Net Amount</th>
            </tr>
          </thead>
          <tbody>
            {invoiceData.map((c) => {
              return (
                <tr>
                  <td className="w-lg fw-500">{c.CPID}</td>
                  <td className="w-lg">{getChargerDetails(c.CPID)}</td>
                  <td>{capitalize(c.PARTNER_TYPE.replace(/_/g, ' '))}</td>
                  <td>{`${getSuffixPrefixOfComission(
                    c?.COMMISSION_TYPE,
                    c?.COMMMISION_VALUE,
                  )}`}</td>
                  <td>{`${round(c.KWH_CONSUMED, 2)} KWh`}</td>
                  <td>{`₹${round(c.COMMISSION_AMOUNT_WITHOUT_TAX, 2)}`}</td>
                  <td>{`₹${round(c.CGST, 2)}`}</td>
                  <td>{`₹${round(c.SGST, 2)}`}</td>
                  <td>{`₹${round(c.COMMISSION_AMOUNT, 2)}`}</td>
                </tr>
              );
            })}
            <tr className="total">
              <td className="w-lg"></td>
              <td className="w-lg"></td>
              <td></td>
              <td></td>
              <td>{sumByKey(invoiceData, 'KWH_CONSUMED')} Kwh</td>
              <td>{`₹${sumByKey(
                invoiceData,
                'COMMISSION_AMOUNT_WITHOUT_TAX',
              )}`}</td>
              <td>{`₹${sumByKey(invoiceData, 'CGST')}`}</td>
              <td>{`₹${sumByKey(invoiceData, 'SGST')}`}</td>
              <td>{`₹${sumByKey(invoiceData, 'COMMISSION_AMOUNT')}`}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default CustomerInvoice;
